<template>
  <div class="search-container">
    <div class="search-main">
      <el-row :gutter="32">
        <el-col :span="17">
          <div class="rank-head">
            <h2 @click="goto('/')" style="cursor: pointer">Acemap</h2>
            <div class="rank-left">
              <div class="rank-left-select">
                <div class="rls-item">
                  <el-cascader
                    v-model="filterValue"
                    :options="filterOptions"
                    :props="props"
                    collapse-tags
                    @change="handleChange"
                  ></el-cascader>
                </div>
                <div class="rank-input">
                  <div class="ri-left">
                    <el-input
                      prefix-icon="el-icon-search"
                      @keyup.enter.native="handleSearch"
                      v-model="tremval"
                      placeholder="Enter your keywords here and start exploring"
                    ></el-input>
                  </div>
                </div>
                <!-- <div class="rls-item">
            <span>Language</span>
            <el-select v-model="value2" class="rls-select" placeholder="请选择">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="rls-item">
            <span>Country</span>
            <el-select v-model="value3" class="rls-select" placeholder="请选择">
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
              </div>
            </div>
            <el-button type="primary" class="search-btn" @click="clickSearch"
              >Search</el-button
            >
          </div>
          <div class="rank-left-body" v-loading="loading">
            <div class="rank-left-list" v-if="paperlist.length > 0">
              <div class="rll-title">
                <div class="rll-title-left">
                  Datasets {{ startnum }} to {{ endnum }} of {{ totals }}
                </div>
                <!-- <div class="rll-title-right">
                  <el-select
                    @change="sortselectchange"
                    v-model="sortvalue"
                    placeholder="Sort by"
                  >
                    <el-option
                      v-for="item in sortoptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div> -->
              </div>
              <div class="rll-main">
                <div
                  class="rll-item"
                  v-for="(i, index) in paperlist"
                  :key="i.id"
                >
                  <!-- <img @click="openurl(i.url)" :src="i.img" alt="" /> -->
                  <div class="rll-i-m">
                    <div class="rll-im-text">
                      <h2 v-if="!handleKeywordDisplay(i.projectName, i.matching_keywords).length">
                        [{{ (papercount - 1) * 20 + index + 1 }}]
                        {{ i.projectName }}
                      </h2>
                      <h2 v-else>
                        [{{ (papercount - 1) * 20 + index + 1 }}]
                        <span :class="{'highlight-name': keyword.flag}" v-for="(keyword, index) in handleKeywordDisplay(i.projectName, i.matching_keywords)" :key="index" @click="handleKeywordClick(keyword)">{{ keyword.label_zh }}</span>
                      </h2>

                      <div class="author">
                        {{ i.projectAdmin }} {{ i.dependUnit }}
                        <span
                          class="link-btn"
                          @click="linkTo(i.projectAdmin_pinyin)"
                          >[立项人信息]</span
                        >
                      </div>
                      <el-tag v-if="i.searchData && i.searchData.name">{{
                        i.searchData.name
                      }}</el-tag>
                      <el-tag
                        v-if="i.searchData && i.searchData.code"
                        type="warning"
                        >{{ i.searchData.code }}</el-tag
                      >
                      <!-- <p>{{ i.projectAbstractC.substring(0, 200) }}</p> -->
                      <p class="abstract" v-if="!handleKeywordDisplay(i.projectAbstractC, i.matching_keywords_in_abs).length">{{ i.projectAbstractC }}</p>
                      <p class="abstract" v-else>
                        <span :class="{'highlight-name': keyword.flag}" v-for="(keyword, index) in handleKeywordDisplay(i.projectAbstractC, i.matching_keywords_in_abs)" :key="index" @click="handleKeywordClick(keyword)">{{ keyword.label_zh }}</span>
                      </p>
                    </div>
                    <!-- <div class="rll-i-bottom">
                    <span @click="handlezan(i.url_md5,i.highlight)" :class="i.highlight==1?'textcolor':''">
                      <img v-if="i.highlight==1" src="../../assets/images/zan1.png" alt="" />
                      <img v-if="i.highlight==-1||i.highlight==0" src="../../assets/images/zan.png" alt="" />
                      {{ i.like }}
                      </span>
                    <span @click="handlecai(i.url_md5,i.highlight)" :class="i.highlight==0?'textcolor':''">
                      <img v-if="i.highlight==0" src="../../assets/images/cai1.png" alt="" />
                      <img v-if="i.highlight==-1||i.highlight==1" src="../../assets/images/cai.png" alt="" />
                      {{i.dislike}}
                      </span>
                  </div> -->
                  </div>
                </div>
              </div>
              <el-pagination
                background
                layout="prev, pager, next"
                @current-change="pagechange"
                :page-size="20"
                :current-page="papercount"
                :total="totals"
              >
              </el-pagination>
            </div>
            <div v-else class="empty-block">
              <i class="iconfont el-icon-files"></i>
              <h3>暂无数据</h3>
            </div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="rank-right">
            <div class="rank-rmain">
              <div class="rr-sec" v-show="nsfcData.length">
                <div class="rr-sec-title">关键词相关基金数逐年统计</div>
                <div
                  id="nsfcChart"
                  ref="nsfcChart"
                  style="width: 298px; height: 300px"
                ></div>
              </div>
              <div class="rr-sec" v-show="paperData.length">
                <div class="rr-sec-title">关键词相关论文数逐年统计</div>
                <div
                  id="paperChart"
                  ref="paperChart"
                  style="width: 298px; height: 300px"
                ></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// import Footer from "@/components/Footer";
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
import acemap from "@/assets/images/acemap.svg";
export default {
  // components: { Footer },
  data() {
    return {
      acemap,
      filterQuery: "",
      filterOptions: [],
      filterValue: [],
      props: {
        value: "id",
        label: "name",
        children: "child",
        multiple: true,
      },
      totals: 0,
      startnum: 1,
      endnum: 1,
      paperlist: [],
      papercount: 1,
      mainheight: 0,
      baseurl: "https://nsfc.acemap.info/",
      tremval: "",
      aktoken: "",
      autoken: "",
      ip: "",
      chartOption: {},
      paperChart: null,
      nsfcChart: null,
      nsfcData: [],
      paperData: [],
      loading: false,
    };
  },
  mounted() {
    this.tremval = this.$route.query.keyword;
    this.filterQuery = this.$route.query.query || "";
    // if (returnCitySN) {
    //   this.ip = returnCitySN["cip"];
    // }
    this.handleSearch();
    this.handleFilter();
  },
  methods: {
    pagechange(e) {
      this.papercount = e;
      this.handleSearch();
    },
    clickSearch() {
      this.papercount = 1;
      this.handleSearch();
      window.scrollTo(0, 0);
      // this.getpaper(true);
      // this.getreport(true);
    },
    openurl(e) {
      window.open(e);
    },
    drawNsfcChart(nsfcData) {
      if (nsfcData.length) {
        const nsfcDateList = nsfcData.map(function (item) {
          return item.year;
        });
        const nsfcValueList = nsfcData.map(function (item) {
          return item.count;
        });
        this.nsfcChart = this.$echarts.init(
          document.getElementById("nsfcChart")
        );
        const nsfcOption = {
          // Make gradient line here
          visualMap: [
            {
              show: false,
              type: "continuous",
              seriesIndex: 0,
              min: 0,
            },
          ],
          tooltip: {
            trigger: "axis",
          },
          xAxis: [
            {
              data: nsfcDateList,
            },
          ],
          yAxis: [{}],
          grid: {
            bottom: 30,
            left: 40,
            right: 0,
          },
          series: [
            {
              type: "line",
              // showSymbol: false,
              data: nsfcValueList,
            },
          ],
        };
        this.nsfcChart.setOption(nsfcOption);
      }
    },
    drawPaperChart(paperData) {
      if (paperData.length) {
        const paperDateList = paperData.map(function (item) {
          return item.year;
        });
        const paperValueList = paperData.map(function (item) {
          return item.count;
        });
        this.paperChart = this.$echarts.init(
          document.getElementById("paperChart")
        );
        const paperOption = {
          // Make gradient line here
          tooltip: {
            trigger: "axis",
          },
          xAxis: {
            type: "category",
            data: paperDateList,
          },
          yAxis: {
            type: "value",
          },
          grid: [
            {
              bottom: 30,
              left: 50,
              right: 0,
            },
          ],
          series: [
            {
              type: "line",
              // showSymbol: false,
              data: paperValueList,
            },
          ],
        };
        this.paperChart.setOption(paperOption);
      }
    },
    handleSearch() {
      this.loading = true;
      this.$axios
        .get(
          `${this.baseurl}api/v2/search/nsfc?discipline=${this.filterQuery}&keyword=${this.tremval}&page=${this.papercount}&pagesize=20&order=desc&orderby=0`
        )
        .then((response) => {
          console.log("response", response.data);
          const {
            data,
            keyword_in_nsfc_chart,
            keyword_in_paper_chart,
            count,
            page,
            pagesize,
          } = response.data;

          this.totals = count;
          this.startnum = 1 + (page - 1) * pagesize;
          if (count > 20) {
            if (page * pagesize > count) {
              console.log("---185");
              this.endnum = count;
            } else {
              this.endnum = page * pagesize;
            }
          } else {
            this.endnum = count;
          }
          this.paperlist = data;
          this.nsfcData = keyword_in_nsfc_chart;
          this.paperData = keyword_in_paper_chart;
          this.drawNsfcChart(keyword_in_nsfc_chart);
          this.drawPaperChart(keyword_in_paper_chart);
          this.loading = false;
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: "Failed, please try again!",
          });
          this.loading = false;
        });
    },
    handleFilter() {
      const list = this.filterQuery ? this.filterQuery.split(",") : [];
      this.filterValue = list.map((i) => {
        return [i.charAt(0), i];
      });
      console.log("filterValue", this.filterValue);
      this.$axios
        // .get(this.baseurl + "api/v2/home/?cache_es=false&cache_version=1")
        .get(`${this.baseurl}api/v2/home/discipline`)
        .then((res) => {
          this.filterOptions = res.data.data || [];
        });
    },
    goto(path) {
      this.$router.push(path);
    },
    handleChange() {
      this.filterQuery = this.filterValue.length
        ? this.filterValue.map((i) => i[1]).join(",")
        : "";
    },
    linkTo(name) {
      window.open("https://www.acemap.info/searchResults?q=" + name, "_blank");
    },
    handleKeywordDisplay(name, keywords) {
      let wordList = [];
      for (let i = 0; i < keywords.length; i++) {
        const position = keywords[i].position;
        const start = position[0];
        const end = position[1];
        const length = keywords.length;
        const nextKeyword = keywords[i + 1]
        if (i === 0 && start !== 0) {
          let str = name.slice(0, start);
          // 第一个
          wordList.push({
            label_zh: str,
            label_en: "",
            // 是否高亮
            flag: 0,
          });
        }
        // 中间的词
        wordList.push({
          label_zh: keywords[i].keyword_ch,
          label_en: keywords[i].keyword_en,
          // 是否高亮
          flag: 1,
        });
        // 聚集诱导发光型超分子纳米控释材料的构筑及其诊疗一体化应用研究
        if (nextKeyword && end !== nextKeyword.position[0] - 1) {
          let nextStr = name.slice(end + 1, nextKeyword.position[0]);
          wordList.push({
            label_zh: nextStr,
            label_en: "",
            // 是否高亮
            flag: 0,
          });
        }
        if (i === length - 1 && (end !== name.length - 1)) {
          let str = name.slice(end + 1, name.length);
          // 最后一个
          wordList.push({
            label_zh: str,
            label_en: "",
            // 是否高亮
            flag: 0,
          });
        }
      }
      return wordList;
    },
    handleAbstractDisplay(item) {
      let wordList = [];
      const name = item.projectAbstractC;
      const keywords = item.matching_keywords_in_abs;
      if (keywords.length) {
        const position = keywords[0].position;
        const start = name.slice(0, position[0]);
        const middle = name.slice(position[0], position[1] + 1);
        const end = name.slice(position[1] + 1, name.length);
        wordList = [start, middle, end];
      }
      return wordList;
    },
    handleKeywordClick(item) {
      if (!item.flag) {
        return
      }
      this.linkTo(item.label_en)
    }
  },
};
</script>

<style scoped lang="less">
#app {
  background-color: rgb(241, 241, 241);
}
* {
  font-family: ddefont;
}
div {
  box-sizing: border-box;
}
.search-container {
  background: #f0f2f5;
  padding: 10px;
  min-height: calc(100vh - 16px);
  .search-main {
    // width: 1200px;
    width: 1400px;
    overflow: hidden;
    margin: 30px auto;
  }
  .rank-left {
    width: 100%;
    // float: left;
    // width: 1060px;
    .rank-left-select {
      width: 100%;
      display: flex;
      .rls-item {
        display: inline-block;
        margin-left: 13px;
        font-size: 17px;
        width: 160px;
        margin-right: 12px;
        .el-select {
          width: 100%;
        }
        span {
          font-weight: bold;
          display: inline-block;
          margin-right: 5px;
        }
      }
      .rank-input {
        flex: 1;
        display: flex;
        // margin-left: 20px;
      }
      .ri-left {
        flex: 1;
      }
    }
  }
  .rank-left-body {
    // float: left;
    // width: 595px;
    // width: 65%;
    // margin-left: 15px;
    .rank-left-list {
      width: 100%;
      background-color: #fff;
      // cursor: pointer;
      margin-top: 40px;
      padding: 10px 20px 20px;
      // box-shadow: 2px 2px 10px rgba(0, 0, 0, 25%);
      border-radius: 4px;
      // border: 1px solid #ebeef5;
      .rll-title {
        font-weight: bold;
        font-size: 17px;
        margin-bottom: 20px;
        overflow: hidden;
        .rll-title-right {
          float: right;
        }
        .rll-title-left {
          float: left;
          line-height: 40px;
        }
      }
      .rll-main {
        width: 100%;
        overflow: hidden;
        margin-bottom: 20px;
        // overflow-y: auto;
        // height: calc(100vh - 400px);
        .rll-item {
          width: 100%;
          display: flex;
          margin-bottom: 36px;
          img {
            width: 185px;
            height: 128px;
            margin-right: 20px;
            margin-top: 1px;
          }

          .rll-i-m {
            flex: 1;
            font-size: 15px;
            // line-height: 18px;
            color: rgb(167, 164, 162);
            .rll-im-text {
              h2 {
                font-weight: bold;
                font-size: 18px;
                margin-bottom: 8px;
                color: rgb(6, 105, 170);
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden; //溢出内容隐藏
                text-overflow: ellipsis; //文本溢出部分用省略号表示
                display: -webkit-box; //特别显示模式
                -webkit-line-clamp: 2; //行数
                line-clamp: 2;
                -webkit-box-orient: vertical; //盒子中内容竖直排列
                .highlight-name {
                  text-decoration: underline;
                  &:hover {
                    cursor: pointer;
                    color: #77b8fa;
                  }
                }
              }
              .author {
                margin-bottom: 6px;
              }
              .link-btn {
                margin-left: 12px;
                color: #77b8fa;
                &:hover {
                  cursor: pointer;
                  text-decoration: underline;
                }
              }
              .abstract {
                margin-top: 12px;
                .highlight-name {
                  text-decoration: underline;
                  color: #77b8fa;
                  &:hover {
                    cursor: pointer;
                    font-weight: 500;
                  }
                }
              }
              p {
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden; //溢出内容隐藏
                text-overflow: ellipsis; //文本溢出部分用省略号表示
                display: -webkit-box; //特别显示模式
                -webkit-line-clamp: 6; //行数
                line-clamp: 6;
                -webkit-box-orient: vertical; //盒子中内容竖直排列
                color: #000;
              }
            }
          }
        }
      }
    }
  }
  .rank-right {
    // float: right;
    // width: 350px;
    // width: 30%;
    // padding: 20px;
    // border: 1px solid gray;
    // box-shadow: 1px 1px 5px gray;
    // margin-top: 30px;
    .rr-title {
      font-weight: bold;
      font-size: 20px;
    }
    .rr-sec {
      width: 100%;
      margin-bottom: 30px;
      border-radius: 5px;
      background-color: #fff;
      padding: 20px;
      // box-shadow: 2px 2px 10px rgba(0, 0, 0, 25%);
      border-radius: 4px;
      // border: 1px solid #ebeef5;
      .rr-sec-title {
        font-size: 17px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
}
#echartsWordcloud {
  width: 100%;
  height: 200px;
}
.search-btn {
  margin-left: 20px;
  font-size: 22px;
}
.rank-rmain {
  overflow: hidden;
  overflow-y: auto;
  padding: 10px;
  // height: calc(100vh - 330px);
}
.rank-search-sec {
  float: left;
  width: 210px;
  margin-top: 30px;
  padding: 10px;
}
.rss-title {
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
  border-bottom: 1px solid black;
}
.rank-head {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  h2 {
    line-height: 60px;
    color: #0962bc;
    font-weight: 900;
    font-size: 42px;
    margin-right: 24px;
  }
}
.rank-body {
  width: 100%;
  overflow: hidden;
}
.rss-main {
  width: 100%;
  padding: 20px 10px;
}
.rss-m-body {
  margin: 10px 0;
}
.rss-m-bodyoy {
  overflow: hidden;
  // overflow-y: auto;
}
.showmorebtn {
  cursor: pointer;
  font-weight: normal;
  font-size: 14px;
  color: #409eff;
  margin-top: 10px;
  margin-bottom: 20px;
}
.rss-m-head {
  font-size: 15px;
}
.empty-block {
  background: #fff;
  height: 500px;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 120px;
    color: rgba(0, 0, 0, 0.35);
  }
  h3 {
    font-size: 22px;
    margin-top: 24px;
    color: rgba(0, 0, 0, 0.45);
  }
}
.rll-i-bottom {
  text-align: right;
  font-weight: 500 !important;
  padding-right: 10px;
  padding-top: 3px;
  .textcolor {
    color: #0669aa;
  }
  img {
    width: 15px !important;
    height: 15px !important;
    margin: 0 !important;
    vertical-align: text-top;
  }
  span {
    font-weight: 500 !important;
    font-family: "Courier New", Courier, monospace !important;
  }
}
.dialog-item {
  display: flex;
  margin-bottom: 10px;
  span {
    display: inline-block;
    width: 100px;
    line-height: 36px;
    font-size: 16px;
  }
  .dialog-i-right {
    flex: 1;
  }
}
</style>
<style>
.dialog-item input {
  font-size: 16px;
  font-family: ddefont;
}
/* .rls-select {
  width: 250px !important;
} */
.el-pagination .el-pager .active {
  background-color: rgb(0, 144, 166) !important;
}
/* .el-checkbox {
  width: 100% !important;
} */
.rss-m-body .el-checkbox__label {
  font-size: 12px !important;
}
.rss-mb-span {
  width: 100px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
.rank-input .el-icon-search {
  font-size: 25px !important;
  line-height: 40px !important;
  color: #409eff !important;
}
.rank-left .el-input__inner {
  height: 62px !important;
  font-size: 18px;
}
.rank-input .el-input__inner {
  padding-left: 50px !important;
}
.ri-left .el-input__prefix {
  left: 15px;
}
.search-container .el-dialog__body {
  padding: 20px 20px 10px;
}
.rankdialog .el-button {
  font-size: 14px !important;
  font-family: ddefont;
  padding: 12px;
}
</style>




// WEBPACK FOOTER //
// src/pages/Search/index.vue